import React from 'react';
import { Field } from 'redux-form';
import { renderCheckboxPillField } from '../utils/forms';

/**
 * Single source of truth for the per-endpoint external API access toggles,
 * grouped by category. Used by CustomerAddForm / CustomerEditForm (as redux-form
 * Fields) and by CustomerDetailsView (read-only status), so the endpoint list
 * stays in sync everywhere.
 *
 * Each `key` maps to the nested ApiAccess path: `ApiAccess.<category>.<key>`.
 */
export const API_ACCESS_GROUPS = [
  {
    category: 'Catalog', label: 'Catálogo (lectura)', icon: 'fa-list',
    endpoints: [
      { key: 'Machines', label: 'Listar máquinas',     path: '/v1/locker-machines', icon: 'fa-server' },
      { key: 'Lockers',  label: 'Listar lockers',       path: '/v1/locker-list',     icon: 'fa-th' },
      { key: 'Locker',   label: 'Estado de un locker',   path: '/v1/locker-info',     icon: 'fa-square' },
    ],
  },
  {
    category: 'Operations', label: 'Operaciones', icon: 'fa-bolt',
    endpoints: [
      { key: 'Rent',    label: 'Alquilar',          path: '/v1/locker-rent',    icon: 'fa-key' },
      { key: 'Release', label: 'Liberar',           path: '/v1/locker-release', icon: 'fa-unlock' },
      { key: 'Reserve', label: 'Reservar QR / PDA',  path: '/v1/locker-reserve', icon: 'fa-qrcode' },
    ],
  },
  {
    category: 'Maintenance', label: 'Mantenimiento', icon: 'fa-wrench',
    endpoints: [
      { key: 'Fault',  label: 'Marcar avería', path: '/v1/locker-fault',  icon: 'fa-exclamation-triangle' },
      { key: 'Repair', label: 'Reparar avería', path: '/v1/locker-repair', icon: 'fa-tools' },
    ],
  },
  {
    category: 'Telemetry', label: 'Telemetría', icon: 'fa-heartbeat',
    endpoints: [
      { key: 'Health', label: 'Salud de máquinas', path: '/v1/locker-health', icon: 'fa-heartbeat' },
    ],
  },
];

const groupHeaderStyle = {
  display: 'flex', alignItems: 'center', gap: 8,
  padding: '0 0 8px',
  fontWeight: 600, fontSize: '12px', color: '#495057',
  textTransform: 'uppercase', letterSpacing: '0.5px',
};

// Grouped redux-form Field pills — one COLUMN per category, endpoints stacked.
const ApiAccessFields = () => (
  <div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '16px', padding: '0 12px', alignItems: 'start',
  }}>
    {API_ACCESS_GROUPS.map((group) => (
      <div key={group.category}>
        <div style={groupHeaderStyle}>
          <i className={`fas ${group.icon}`} style={{ color: '#ffae00' }} />
          {group.label}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {group.endpoints.map((ep) => (
            <Field
              key={ep.key}
              name={`ApiAccess.${group.category}.${ep.key}`}
              component={renderCheckboxPillField}
              label={`${ep.label} (${ep.path})`}
              icon={ep.icon}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default ApiAccessFields;
